export default __webpack_public_path__ + "static/media/imgSpinLa.ec5fbd6f.png";